/* eslint-disable no-console, indent, capitalized-comments, no-tabs, no-unused-vars, multiline-comment-style */
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { useAuth } from "../services/wp.auth.service";

const RequireAuth = ({
	children,
	requireRole,
	requireStatus
}) => {
	const { user } = useAuth();
	const location = useLocation();
	if (!user) {

		/*
		 * Redirect them to the /login page, but save the current location they were
		 * trying to go to when they were redirected. This allows us to send them
		 * along to that page after they login, which is a nicer user experience
		 * than dropping them off on the home page.
		 */

		return (
			<Navigate
				replace
				state={{
					from: location
				}}
				to="/"
			/>
		);
	} else if (requireRole !== "" && user.roles.indexOf(requireRole) === -1) { /* eslint-disable-line no-magic-numbers */

		return (
			<Navigate
				replace
				to="/"
			/>
		);

	} else if (requireStatus && user.status !== requireStatus) {
		return (
			<Navigate
				replace
				to="/"
			/>
		);
	}

	return children;
};

RequireAuth.propTypes = {
	children: PropTypes.node.isRequired,
	requireRole: PropTypes.string,
	requireStatus: PropTypes.string
};

RequireAuth.defaultProps = {
	requireRole: "",
	requireStatus: null
};

export default RequireAuth;
